import { type Brand } from '@/consts/brands';

export const getHumanReadableBrandName = (brand: Brand) => {
  if (brand) {
    return brand.charAt(0).toUpperCase() + brand.slice(1);
  }
};

export const isFourDigitVerificationCode = (verificationCode: string) => {
  return verificationCode.length === 4;
};

export const phoneNumberIsValid = (phoneNumber: string) => {
  return phoneNumber.replaceAll('-', '').trim().length >= 10;
};
